import { SearchIcon, CloseIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Checkbox,
  CloseButton,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  Radio,
  RadioGroup,
  Text,
  VStack,
} from '@chakra-ui/react';
import {
  ChatMemberIcon,
  InviteFriends,
  MyNetworkNewIcon,
  TeamIcon,
  TeamNewIcon,
} from '@mybridge/icons';

import { Avatar, Image } from '@mybridge/ui';
import React, { useContext, useEffect, useState } from 'react';
import MembersPopup from './members-popup';
import { useDispatch, useSelector } from 'react-redux';
import { MyNetworkContext } from 'v4/components/network/context';
import { getNextPageFromURL } from 'v4/utils/utils';
import { useInfiniteQuery } from '@tanstack/react-query';
import {
  getAllConnectionsData,
  getBlockedUserList,
  getChatRoomBlockedUserList,
  getInvitations,
  unblockRoomUser,
} from 'v4/store/actions/connection.actions';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

const BlockedUserPopup = ({roomId, blockedMemberPopup, setBlockedMemberPopup,fetchRoomList, getSelectedRoomMembersData }) => {
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const {unblockUser} = useContext(MyNetworkContext);
  const [blockedUserList,setBlockUserList] = useState([]);
  const [unblockedUser, setUnblockedUser] = useState(null)

  useEffect(() => {
    if (blockedMemberPopup) {
      dispatch(getChatRoomBlockedUserList(roomId)).then((res) => {
        setBlockUserList(res?.payload?.users)
      });
    }
  }, [blockedMemberPopup, dispatch]);


  const handleUnblockUser = async (userId) => {
    try {
      const response = await dispatch(unblockRoomUser({roomId, user_id: userId})); 
      if (response?.state_code >= 400) {

    
      } else {
        fetchRoomList();
        getSelectedRoomMembersData();
        setBlockedMemberPopup(false); 
      }
    } catch (error) {
      console.error("Error in blocking user:", error);

    }
  };
  return (
    <>
      <Modal
        isOpen={blockedMemberPopup}
        onClose={() => setBlockedMemberPopup(false)}
      >
        {/* <ModalOverlay /> */}
        <ModalContent marginTop="150px">
          {/* <ModalCloseButton /> */}
          <ModalHeader>
            <HStack justifyContent="space-between">
              <Text
                fontFamily="Inter"
                fontSize="15px"
                fontWeight={600}
                lineHeight="18px"
                textAlign="left"
                textUnderlinePosition="from-font"
                textDecorationSkipInk="none"
                color="#5B5B5B"
              >
                {t('myMessages.blockedNetwork') || 'Blocked Network'}
              </Text>
              <CloseIcon
                width={'10px'}
                height={'10px'}
                onClick={() => setBlockedMemberPopup(false)}
              />
            </HStack>
          </ModalHeader>
          <ModalBody>
            <VStack
              align="stretch"
              spacing={4}
              overflow={'auto'}
              sx={{
                '&::-webkit-scrollbar': {
                  width: '5px',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#C8C8C8',
                  borderRadius: '51px',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: '#555',
                },
                '&::-webkit-scrollbar-track': {
                  background: '#EDEDED',
                },
              }}
              height="45vh"
            >
              {blockedUserList?.length > 0 ? (
                blockedUserList?.map((user) => (
                  <HStack
                    key={user?.user_id}
                    justifyContent="space-between"
                    cursor="pointer"
                    pr={2}
                  >
                    <HStack spacing={3}>
                      <Avatar
                        src={user?.avatar_url}
                        name={user?.display_name}
                      />

                      <Box>
                        <Text
                          textTransform="capitalize"
                          fontWeight="bold"
                          fontSize="sm"
                        >
                          {user?.display_name}
                        </Text>
                        <Text fontSize="xs" color="gray.500">
                        </Text>
                      </Box>
                    </HStack>

                    <Button
                      onClick={() => {
                        handleUnblockUser(user?.user_id);
                      }}
                      border="1px solid #00000033"
                      borderRadius="27px"
                      bg="#3D5A80"
                      color="#FFFFFF"
                      fontWeight={500}
                      _hover={{
                        background: '#3D5A80',
                      }}
                    >
                      {t('profileNetwork.unblock') || 'Unblock'}
                    </Button>
                  </HStack>
                ))
              ) : (
                <VStack justifyContent="center" alignItems="center" pt={20}>
                  <Image height={150} width={250} objectFit="cover" objectPosition="center" src="/images/defaultBlocked.svg" alt="Blocked users" />
                  <Text fontSize={'sm'} pt={3}>
                    {t('profileNetwork.blockedUsersAppearHere') ||
                      'Blocked users will appear here.'}
                  </Text>
                </VStack>
              )}
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default BlockedUserPopup;
